// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1xp-x","left":"StickyBox_left__1APe6","right":"StickyBox_right__Tl4wc"};